/**
 *
 * AddEditSpace
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import {
  StyledFormField,
  StyledLabel,
} from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { MedalSubscriptionIcon } from '../../../../components/Icons/Icons.component';
import { LocalStyledRadioButton, StyledWrap } from './styles';
import { fontColorSecond } from '../../../../assets/styledAssets/vars';
import { Space, SpaceMember } from '../../spaces';
import SpaceService from '../../../../service/Space.service';
import { CurrentPlan } from '../../../Settings/settings';

const nameToColor: any = {
  'Plan Basic': '#ac7435',
  'Plan Silver': '#c0c2c3',
  'Plan Gold': '#f9db1e',
  'Plan Platinum': '#96979b',
};

interface IProps {
  onCancel: () => void;
  onSave: (s: Partial<Space>) => void;
  onDelete?: (id: string) => void;
  space?: Space;
}

const AddEditSpace: FunctionComponent<IProps> = ({
  onCancel,
  onSave,
  onDelete,
  space,
}) => {
  const intl = useIntl();
  const [spaceDetails, setSpaceDetails] = useState<Partial<Space>>(space || {});
  const [listMembers, setListMembers] = useState<SpaceMember[]>([]);
  const [subPlan, setSubPlan] = useState<CurrentPlan>();
  const handleChangeName = (val: string) => {
    if (spaceDetails) {
      setSpaceDetails({ ...spaceDetails, name: val });
    }
  };

  const handleChangeOwner = (val: string) => {
    if (spaceDetails) {
      setSpaceDetails({ ...spaceDetails, ownerId: val });
    }
  };

  useEffect(() => {
    if (spaceDetails?.id) {
      SpaceService.fetchListAdmins(spaceDetails?.id as string, 1000, 0).then(
        (res) => {
          setListMembers(res);
        },
      );
      SpaceService.fetchCurrentSubscription(spaceDetails?.id as string).then(
        (res) => {
          setSubPlan(res);
        },
      );
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.name)}</StyledLabel>
              <StyledFormField>
                <Input
                  onChange={(e) => handleChangeName(e.target.value as string)}
                  value={spaceDetails?.name}
                />
              </StyledFormField>
            </Column>
          </Wrap>
          {spaceDetails && spaceDetails.id && subPlan && (
            <Wrap margin={'0 0 3rem'} width={'100%'}>
              <Column xs={100} md={100}>
                <StyledLabel>
                  {intl.formatMessage(messages.subscription)}
                </StyledLabel>
                <Wrap margin={'1rem 0 3rem 1rem'}>
                  <MedalSubscriptionIcon
                    width={'2rem'}
                    color={nameToColor[subPlan.subscriptionPlan.title]}
                  />
                  <Wrap
                    margin={'0 0 0 1rem'}
                    fw={'bold'}
                    color={nameToColor[subPlan.subscriptionPlan.title]}
                  >
                    {subPlan.subscriptionPlan.title}
                  </Wrap>
                </Wrap>
              </Column>
            </Wrap>
          )}
          {spaceDetails && spaceDetails.id && (
            <Wrap width={'100%'}>
              <Column xs={100} md={100}>
                <StyledLabel>
                  {intl.formatMessage(messages.spaceOwnerAdmins)}
                </StyledLabel>
                <Wrap
                  flexDir={'column'}
                  overflow={'auto'}
                  flexWrap={'nowrap'}
                  maxHeight={'50vh'}
                >
                  {listMembers.map((m, index) => (
                    <StyledWrap key={`member-${index}`}>
                      <Wrap flexDir={'column'}>
                        <Wrap fs={'1.6rem'} margin={'0 0 1rem'}>
                          {m.person.firstName} {m.person.lastName}
                        </Wrap>
                        <Wrap fs={'1.4rem'} color={fontColorSecond}>
                          {m.person.email}
                        </Wrap>
                      </Wrap>
                      <Wrap flexDir={'row-reverse'}>
                        <LocalStyledRadioButton
                          name="owners"
                          value={m.personId}
                          checked={m.personId === spaceDetails.ownerId}
                          label={intl.formatMessage(messages.spaceOwner)}
                          onChange={(e) => handleChangeOwner(e.value)}
                        />
                      </Wrap>
                    </StyledWrap>
                  ))}
                </Wrap>
              </Column>
            </Wrap>
          )}
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        {spaceDetails.id && onDelete && (
          <StyledModalAction
            primary
            onClick={() => onDelete(spaceDetails.id as string)}
          >
            {intl.formatMessage(messages.delete)}
          </StyledModalAction>
        )}

        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(spaceDetails)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(AddEditSpace);
